import { DocumentService } from '../services/DocumentService';

export function useDocumentService(): DocumentService {
  return new DocumentService(useApiClient(), useUserStore());
}
